import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/Modal/index'
import TextField from './JustificationTextField'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import moment from 'moment'
import Select from 'component/Select/Select'
import { objectsEqual, hasEmptyProperties } from 'utils/validations'
import { connect } from 'react-redux'
import * as ircActions from 'action/irc'
import { showSpinner, hideSpinner } from 'action/spinner'
import { bindActionCreators } from 'redux'
import ErrorModal from 'component/Modal/ErrorModal'
import { translate } from 'react-i18next'
import iconAdd from 'images/add.svg'
import iconAddGray from 'images/add-gray.svg'


class FormModal extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    edit: PropTypes.object,
    newValues: PropTypes.object,
    toggleEdit: PropTypes.func,
    isUserMatriz: PropTypes.bool.isRequired,
    fetchPositions: PropTypes.func.isRequired,
    auth: PropTypes.object,
    showSpinner: PropTypes.func,
    hideSpinner: PropTypes.func,
    maxDays: PropTypes.number,
    hideModal: PropTypes.bool.isRequired,
    onAddJustifications: PropTypes.func
  }


  get typeOptions() {
    const options = [

      {
        label: "C050 Loja",
        value: "1"
      },

      {
        label: "C010 Supply",
        value: "0"
      },
    ] 
    return options 
  }

  getDepositOptionsParams = (values) => {
    const {user} = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values, "")
    .then(resp => {
      const depositTypes = resp.data.split(",").map((item) => ({label: item, type:item, positions:[], deposit: item, value: [{label: "", value: ""}]}))
      this.setState({depositTypeOptions: depositTypes})
    })
  }

  state = {
    depositTypeOptions: [],
    disabled: false,
    justifications: [],
    values: {
      dsListName: '',
      type: '',
      positionsPerDay: '',
      period: [],
      idBranch: '',
    
      selectedPositions: [],
      positions: [{ deposit: '', position: [] }]
    },
    modalError: {
      render: false,
      type: null
    },

    positionsValues: [
     
    ]
  }

  componentDidMount() {
    const depositTypeParams = {
      dsKey: 'irc.supply.deposit.type',
      nuParameter: 1
    }

    this.getDepositOptionsParams(depositTypeParams)
    const { edit, newValues } = this.props

    if (edit && !edit.inEdit && edit.idInventoryCriteria) {
      this.fetchList(edit.idInventoryCriteria)
    } else if (edit && edit.inEdit && newValues) {
      this.fillFields(newValues)
    }
  }

  fetchList = async (idInventoryCriteria) => {
    const { user, toggleEdit } = this.props

    if (user) {
      this.setState({ loading: true })
      const query = { idInventoryCriteria }

      try {
        const { data } = await new Api(user.dsToken).get(
          API_URL.INVENTORY_CRITERIA_FETCH_ID,
          query
        )
        this.fillFields({
          ...data,
          dsListName: 'Lista Critérios Posições X',
          idBranch: '0001',
          positionsPerDay: '20',
          positions: [
            { deposit: 'RSS', position: 'L01-01-01' },
            { deposit: 'RSS', position: 'J12-01-01' },
            { deposit: 'RSS', position: 'Y12-01-01' },
          ]
        })
      } catch (error) {
        console.error(error)
        toggleEdit(false)
      } finally {
        this.setState({ loading: false })
      }
    }
  }

  fillFields(list) {
    const { values } = this.state

    this.setState({
      values: {
        ...values,
        idInventoryCriteria: list.idInventoryCriteria,
        dsListName: list.dsListName,
        idBranch: list.idBranch,
        period: list.period || [moment(list.dtBegin), moment(list.dtEnd)],
        positionsPerDay: list.positionsPerDay,
        positions: list.positions
      }
    });
  }

  handleChange = (name, value, callback) => {
    this.setState({
      values: {
        ...this.state.values,
        [name]: value
      }
    }, () => callback?.())
  }

  isJustificationsEmpty() {
    const {justifications} = this.state
    return justifications.some(obj => obj.dsJustification === '');
  }

  isBtnDisabled() {
    const { values } = this.state
    let disabled = false

    const toValidate = [
      'dsListName',
      'type'
    ]
    
    for (const field of toValidate) {
      if (
        (Array.isArray(values[field]) && values[field].length === 0) ||
        !values[field]
      ) {
        disabled = true
      }

      else if ( !values.type) {
        disabled = true
      }

    return disabled

    }
  }

  isEqual(a, b) {
    if (!a && !b) return true

    if ((!a && b) || (a && !b)) return false

    if (a.length === 0 && b.length === 0) return true

    if (a.filter(aObject => b.find(bObject => objectsEqual(bObject, aObject))).length !== a.length) return false

    if (b.filter(bObject => a.find(aObject => objectsEqual(aObject, bObject))).length !== b.length) return false

    return true
  }

  sameValues() {
    const { edit } = this.props
    const { values } = this.state
    let sameValues = true

    const toValidate = [
      'dsListName',
      'idBranch',
      'positionsPerDay',
    ]

    if (!hasEmptyProperties(edit)) {
      for (const field of toValidate) {
        if (values[field] !== edit[field]) sameValues = false
      }

      if (
        !moment(edit.dtBegin).isSame(values.period[0])
        || !moment(edit.dtEnd).isSame(values.period[1])
      ) {
        sameValues = false
      }

      if (!this.isEqual(edit.positions, values.positions)) sameValues = false
    } else {
      sameValues = false
    }

    return sameValues
  }

  formIsEmpty() {
    const { edit } = this.props
    const { values } = this.state
    let isEmpty = true

    if (!hasEmptyProperties(edit)) {
      isEmpty = false
    } else {
      const strings = ['dsListName', 'positionsPerDay', 'idBranch']
      const stringsIsEmpty = strings.filter(string => values[string] !== '').length === 0
      const periodIsEmpty = values.period.length === 0
      const positionIsEmpty = values.positions.length === 1 && values.positions[0].deposit.length === 0 && values.positions[0].position.length === 0
      const justificationsEmpty = this.state.justifications.length === 0
      if (!stringsIsEmpty || !periodIsEmpty || !positionIsEmpty || !justificationsEmpty) isEmpty = false
    }

    return isEmpty
  }

  onSubmit = () => {
    const { toggleEdit, onSubmit } = this.props

    const { values,justifications } = this.state

    const newValues = {...values}
    newValues.justifications =  justifications
    onSubmit(newValues)

    if (toggleEdit) {
      toggleEdit(false)
    }
  }

  addOption = () => {
    const copy = Array.from(this.state.values.positions)
    copy.push({ deposit: '', position: '' })
    this.setState({
      values: { ...this.state.values, positions: copy }
    })
  }

  removeOption = (i) => {

    const copyOptions = Array.from(this.state.values.positions)
    const removed = copyOptions[i]

    const copySelected = Array.from(this.state.values.selectedPositions).map(selected => selected.deposit === removed.deposit ? {...selected, positions: []} : {...selected})

    const filteredOptions = copyOptions.filter((item) => item.position !== removed.position)
    this.setState({

      values: {
        ...this.state.values,
        selectedPositions: copySelected,
        positions: filteredOptions,
      }
    })
  }

  renderModalError = () => {
    const { translate } = this.props


    return (

      <ErrorModal
        size='sm'
        handleClose={() =>
          this.setState({
            modalError: {
              render: false,
              type: null,
            },
          })
        }
        msg={translate("irc.supply.fetch.positions.error")}
        t={translate}
        center
        buttonText={translate('ok_button')}
      />
    )
  }

  fetchPositions = async (store,type, index ) => {
    const {user, showSpinner, hideSpinner} = this.props
    const {values} = this.state
    const requestBody = {
      addressWharehouseRequest:
      { storeList: [{storeId:store,warehouseType:type}]}
    }

  return new Api(user.dsToken).post(API_URL.IRC_LIST_POSITIONS, requestBody)
  .then(showSpinner())
  .then((response ) => {
    hideSpinner()
    return response
  }).catch(() =>  {
    const copy = Array.from(values.positions)
    copy[index].deposit = ""
    copy[index].position = []
    this.setState({values: {...values, positions: copy}, modalError: {render: true, type: null}})

    hideSpinner()
  })
  }

  addJustificationOption() {
    this.setState(prevState => {
      const newJustifications = [...prevState.justifications,  {dsJustification: ""}];

      if(this.props.onAddJustifications){
        this.props.onAddJustifications(newJustifications);
      }

      return { justifications: newJustifications };
    });
      
  }

  handleRightIconClick = (index) => {
    const { justifications } = this.state;
    const justification = justifications[index];
  
    if (justification.dsJustification) {
      // Se houver texto, limpe o texto
      this.setState(prevState => {
        const newJustifications = [...prevState.justifications];
        newJustifications[index].dsJustification = '';
        return { justifications: newJustifications };
      });
    } else {
      // Se não houver texto, exclua a justificativa do array
      this.setState(prevState => ({
        justifications: prevState.justifications.filter((_, i) => i !== index)
      }));
    }
  }


  updateJustification = (index, value) => {
    this.setState(prevState => {
      const newJustifications = [...prevState.justifications];
      newJustifications[index].dsJustification = value; // Atualiza o valor da justificativa
      return { justifications: newJustifications };
    });
  }

  renderJustifications() {
    const {justifications} = this.state
    
    return (
      justifications.map((justification, index) => (
        <TextField
          onRightIconClick={() => this.handleRightIconClick(index)}
          key={index} // Importante para React identificar cada componente corretamente
          required
          label={"Justificativa"}
          placeholder={"Digite a justificativa"}
          alwaysShow
          fill
          clearIcon
          onChange={(e) => this.updateJustification(index, e.target.value)} // Chama a função de atualização ao alterar o texto
          translate={translate}
          value={justification.dsJustification} // Define o valor do TextField com base no estado
          validateValue={(v) => Boolean(v)}
        />
      ))
    )
  }
  
  render() {
    const { translate, toggleEdit = () => { }, hideModal } = this.props
    const { values, justifications } = this.state
    const disabledBtn = this.isBtnDisabled()

    return (
      <Modal
        invisible={hideModal}
        className={`justification-modal irc-form-modal`}
        title={"Cadastro de justificativa"}
        cancelButtonText={"Cancelar"}
        confirmButtonText={"Cadastrar"}
        disabledBgClickClosing
        isConfirmButtonDisabled={this.isBtnDisabled() || this.isJustificationsEmpty()}
        isOpen
        noCloseOnConfirm
        onConfirm={this.onSubmit}
        onCloseModal={(this.sameValues() || this.formIsEmpty()) ? () => toggleEdit(false) : () => toggleEdit(true,true)}
      >
        <form action='#' onSubmit={(e) => e.preventDefault()} className='w-100'>

          <Select
            fill
            placeholder="Selecione o tipo de justificativa"
            required
            label={translate('type')}
            options={this.typeOptions}
            onChange={(e) => this.handleChange('type', e.value)}
            value={this.typeOptions.find(({ value }) => value === values.type)}
            validateValue={(v) => (v.value || '').length > 0}
          />  

         <TextField
           required
           clearIcon
           label={"Justificativa"}
           placeholder={"Digite a justificativa"}
           name={'dsListName'}
           onRightIconClick={() => this.handleChange("dsListName", "")}
           fill
           onChange={(e) => this.handleChange('dsListName', e.target.value)}
           translate={translate}
           value={values.dsListName}
           validateValue={(v) => Boolean(v)}
          />

         
        <div className='justifications-stack'>
          {this.renderJustifications()}
        </div>
          
         <div onClick={() => !disabledBtn && this.addJustificationOption(justifications)} className={`add-justifications-irc ${disabledBtn ? 'disabled' : ''}`}>
            <img src={disabledBtn ? iconAddGray : iconAdd} /> <span>Adicionar mais campo de justificativa</span>
         </div>

        </form>
      </Modal>
    )
  }
}

const mapStateToProps = ({ircReducer }) => ({
  listPostiion: ircReducer.list.records,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({...ircActions, showSpinner,hideSpinner}, dispatch)


  const FormModalTranslated = translate(null, {
    wait: true,
    translateFuncName: 'translate'
  })(FormModal)

export default  connect(mapStateToProps, mapDispatchToProps) (FormModalTranslated)
export { FormModal }
